// src/hooks/useSnippets.js
import { useState, useCallback } from "react";
import SYSTEM_SNIPPETS from "../script/SNIPPETS.js";

const STORAGE_KEY = "visuallab_snippets";

const loadCustomSnippets = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

const saveCustomSnippets = (snippets) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(snippets));
};

const useSnippets = () => {
  const [customSnippets, setCustomSnippets] = useState(loadCustomSnippets);

  const allSnippets = [...SYSTEM_SNIPPETS, ...customSnippets];

  const addSnippet = useCallback((name, description, code) => {
    const snippet = {
      name: name.trim().toLowerCase().replace(/\s+/g, "-"),
      description: description.trim(),
      code: code.trim(),
      custom: true,
    };
    setCustomSnippets((prev) => {
      const next = [...prev.filter((s) => s.name !== snippet.name), snippet];
      saveCustomSnippets(next);
      return next;
    });
  }, []);

  const deleteSnippet = useCallback((name) => {
    setCustomSnippets((prev) => {
      const next = prev.filter((s) => s.name !== name);
      saveCustomSnippets(next);
      return next;
    });
  }, []);

  return { allSnippets, customSnippets, addSnippet, deleteSnippet };
};

export default useSnippets;
